const baseCompanyRevenueApiUrls = "/api/CompanyRevenue";

export const CompanyRevenueApiUrl = {
  GetRevenue: (companyRowID: string) =>
    `${baseCompanyRevenueApiUrls}?companyRowID=${companyRowID}`,
  AdditionalStream: `${baseCompanyRevenueApiUrls}/AdditionalStream`,
};
